
import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import MenuItem from '../containers/MenuItemContainer';
import { headermenu } from '../data/menu';

const Menu = ({
    setIsMenuOpen,
    isMenuOpen,
}) => (
    <ul className="tw-flex tw-flex-col md:tw-flex-row tw-w-full tw-py-4 tw-px-5 md:tw-border-t md:tw-border-[#D0D5DD] tw-mx-auto md:tw-border-b tw-justify-between tw-items-start md:tw-items-center tw-mb-0 tw-gap-4 header-menu-list">
        {
            headermenu.map((item) => (
                <MenuItem
                    key={item.title}
                    title={item.title}
                    to={item.to}
                    action={item.action}
                    Icon={item.Icon || undefined}
                    iconColor={item.iconColor}
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ))
        }
    </ul>
);

Menu.propTypes = exact({
    setIsMenuOpen: PropTypes.func,
    isMenuOpen: PropTypes.bool,
});

export default Menu;
